import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';
import { TextAreaEntry } from '../entries/TextAreaEntry';

export class ScriptTaskPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:ScriptTask';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    return [
      {
        id: 'scriptTask',
        label: i18n.scriptTask || 'Script Task',
        entries: [
          {
            id: 'scriptFormat',
            component: () => (
              <TextFieldEntry
                id="epx-scriptFormat"
                label={i18n.scriptFormat || 'Script Format'}
                value={props.scriptFormat || ''}
                onChange={(val) => update('scriptFormat', val)}
              />
            ),
          },
          {
            id: 'script',
            component: () => (
              <TextAreaEntry
                id="epx-script"
                label={i18n.script || 'Script'}
                value={props.script || ''}
                onChange={(val) => update('script', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
